import type { FormValues } from '../../constants';
import type { CalculationResult } from '../../lib';

export const toCalculatorInput = (values: FormValues) => {
	const {
		featureTrade: _t,
		featureStock: _s,
		featureLogistics: _l,
		featureCrm: _c,
		featureCommunication: _cm,
		featureDocuments: _d,
		featureOtc: _o,
		featureAnalytics: _a,
		featureDashboard: _db,
		featureTraining: _tr,
		featureApi: _api,
		...input
	} = values;
	return input;
};

export const buildRequestData = (values: FormValues, calculation: CalculationResult) => {
	return {
		companyinfo: {
			company: values.company, // Название компании
			activity: values.activity, // Тип рыбной компании (РК)
			name: values.name, // Ваше имя
			phone: values.phone, // Телефон
			employees: values.employees, // Сотрудников коммерческого отдела
			employeeCost: values.employeeCost, // Полная стоимость одного сотрудника в месяц
			orders: values.orders, // Заявок и заказов в месяц
			activeMonths: values.activeMonths, // Активных месяцев продаж в году
		},
		routines: {
			orderMinutes: values.orderMinutes, // Обработка одной заявки
			stockMinutes: values.stockMinutes, // Сверка остатков и обновление прайсов
			reportMinutes: values.reportMinutes, // Сбор отчётности руководителем
			priceMinutes: values.priceMinutes, // Запросы цен и обновление предложений
			counterpartyMinutes: values.counterpartyMinutes, // Проверка контрагентов
			communicationMinutes: values.communicationMinutes, // Коммуникация с покупателями
			documentMinutes: values.documentMinutes, // Документы и шаблоны
			otcMinutes: values.otcMinutes, // Регистрация внебиржевых договоров
		},
		spending: {
			volume: values.volume, // Объём рыбопродукции в год
			avgPrice: values.avgPrice, // Средняя стоимость продукции
			storageDays: values.storageDays, // Срок хранения от поступления до продажи
			storageCost: values.storageCost, // Стоимость хранения
			creditRate: values.creditRate, // Ставка кредитов / стоимость капитала
			hasDeferred: values.hasDeferred, // Есть продажи с отсрочкой?
			deferredSales: values.deferredSales, // Сумма продаж с отсрочкой
			deferredDays: values.deferredDays, // Средний срок отсрочки
			badDebt: values.badDebt, // Безнадёжные долги и неоплаченные счета
			expiredTons: values.expiredTons, // Продукция с истёкшим сроком годности
			expiredLoss: values.expiredLoss, // Себестоимость и утилизация
			markdownTons: values.markdownTons, // Объём продукции с уценкой
			markdownLoss: values.markdownLoss, // Среднее снижение цены при уценке
			weightDiff: values.weightDiff, // Весовые расхождения и пересортица
			returns: values.returns, // Возвраты и претензии покупателей
			hasSite: values.hasSite, // Есть действующий сайт?
			siteSupport: values.siteSupport, // Поддержка сайта
			b2bDevelopment: values.b2bDevelopment, // Разработка собственной B2B-витрины
			hasMarketer: values.hasMarketer, // Есть маркетолог или агентство?
			marketerCost: values.marketerCost, // Маркетолог или агентство
			adBudget: values.adBudget, // Рекламный бюджет
			articles: values.articles, // Статей публикуется
			articleCost: values.articleCost, // Стоимость подготовки одной статьи
			aiMinutes: values.aiMinutes, // Обновление данных компании для поиска и ИИ
			exhibitions: values.exhibitions, // Выставок в год
			exhibitionCost: values.exhibitionCost, // Полные расходы на одну выставку
		},
		tariffProperties: {
			warehouses: values.warehouses, // Количество складов
			users: values.users, // Необходимое количество пользователей
			personalManager: values.personalManager, // Персональный менеджер
			marketingSupport: values.marketingSupport, // Привлечение клиентов и маркетинг
			featureTrade: values.featureTrade, // Торговля и заказы 24/7
			featureStock: values.featureStock, // Управление остатками
			featureLogistics: values.featureLogistics, // Складская логистика
			featureCrm: values.featureCrm, // CRM и проверка контрагентов
			featureCommunication: values.featureCommunication, // Коммуникация участников рынка
			featureDocuments: values.featureDocuments, // Документы и шаблоны
			featureOtc: values.featureOtc, // Внебиржевые договоры
			featureAnalytics: values.featureAnalytics, // Аналитика и отчёты
			featureDashboard: values.featureDashboard, // Панель руководителя
			featureTraining: values.featureTraining, // Обучение и поддержка
			featureApi: values.featureApi, // API и интеграции
		},
		result: calculation, // Результат расчёта калькулятора
	};
};
